import { isReadOnly, type PlanState } from "@/shared/plan";

/**
 * Whether the plan bar may have a notice: a read-only company, for everyone, and a failed payment,
 * for an Admin. The shell checks it before fetching the bar's code, so most sessions never load it.
 */
export function needsPlanBar(context: {
  readonly role: string | null;
  readonly companyPlan?: { readonly state: PlanState } | null;
}): boolean {
  const state = context.companyPlan?.state;
  if (state === undefined) return false;
  return (
    isReadOnly(state) ||
    (context.role === "admin" && state === "payment_failed")
  );
}
